// extracted by mini-css-extract-plugin
module.exports = {"collapsable":"styles-module__collapsable___2snCl"};